import React from 'react';
import { useTranslation } from 'react-i18next';

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const handleChange = (e) => {
    i18n.changeLanguage(e.target.value);
    localStorage.setItem('language', e.target.value);
  };

  React.useEffect(() => {
    const lang = localStorage.getItem('language');
    if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  }, [i18n]);

  return (
    <select
      className="bg-gray-900 text-white border border-gray-700 rounded px-3 py-1 text-sm"
      value={i18n.language}
      onChange={handleChange}
      style={{ position: 'absolute', top: 24, right: 24, zIndex: 50 }}
      aria-label="Sprache wählen"
    >
      <option value="de">🇩🇪 Deutsch</option>
      <option value="en">🇬🇧 English</option>
    </select>
  );
}

export default LanguageSwitcher;
